import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewUserViewVrHistoryList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_USER_VIEW_VR_HISTORY_LIST_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(
        `${BASE_URL}/user-view-vr-history/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_USER_VIEW_VR_HISTORY_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_USER_VIEW_VR_HISTORY_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_USER_VIEW_VR_HISTORY_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewUserViewVrHistory = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_USER_VIEW_VR_HISTORY_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(
        `${BASE_URL}/user-view-vr-history/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_USER_VIEW_VR_HISTORY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_USER_VIEW_VR_HISTORY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_USER_VIEW_VR_HISTORY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const deleteUserViewVrHistory = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_USER_VIEW_VR_HISTORY_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.delete(
        `${BASE_URL}/user-view-vr-history/delete/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_USER_VIEW_VR_HISTORY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "DELETE_USER_VIEW_VR_HISTORY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "DELETE_USER_VIEW_VR_HISTORY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};